import { DateTime } from 'luxon';
import { observable, computed } from 'mobx';

import { getDate, getLocalDateTime } from 'helpers/datetime';
import { BaseFormModel, isRequired } from 'stores/BaseForm';
import { FeedbackReportReqParams } from 'http/Api/Feedback/types';

class FeedbackReportForm extends BaseFormModel {
  @observable
  @isRequired()
  period: [DateTime, DateTime] = [getLocalDateTime(), getLocalDateTime()];

  @computed
  get requestParams(): FeedbackReportReqParams {
    const [from, to] = this.period;

    return {
      startDate: getDate(from.toJSDate()),
      endDate: getDate(to.toJSDate()),
    };
  }
}

export default FeedbackReportForm;
